import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' >
                {/* <img src='/assets/images/logo.png' alt='logo' /> */}

                {(alwaysShowText) &&
                    <h5>Mentr</h5>
                }
            </div>
        </>
    )
}
